import { useEffect } from "react";
import { all_routes } from "../../../feature-module/router/all_routes";
import { useAuth } from "./AuthContext";
import { Navigate, useLocation, useNavigate } from "react-router";

export const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading, selectedOrganization } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // console.log("private route context");
  if (loading) return null;

  if (!isAuthenticated) {
    return <Navigate to={all_routes.login} replace />;
  }

  // useEffect(() => {
  //   // if (!loading && isAuthenticated && !selectedOrganization) {
  //   if (
  //     !selectedOrganization &&
  //     isAuthenticated &&
  //     location.pathname !== all_routes.leadsList
  //   ) {
  //     navigate(all_routes.adminDashboard, { replace: true });
  //   }
  // }, [isAuthenticated, selectedOrganization, location.pathname]);

  // if (loading) return null;

  return <>{children}</>;
};

// console.log("selectedOrganization", selectedOrganization);
// if (!selectedOrganization) {
//   console.log("organization not selected!");
// }
// =======================>>>>>>><<<<<<<<<<========================

// const PrivateRouteContext = createContext<PrivateRouteContextType>({})

// export const useAuth = () => {
//     const context = useContext(PrivateRouteContext)
//     if (!context) {
//         throw new Error("PrivateRouteContext must be inside it's context")
//     }
//     return context
// }

// export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

//     return (
//         <PrivateRouteContext.Provider value={{}}>
//             {children}
//         </PrivateRouteContext.Provider>
//     )
// }
